/* eslint-disable */
import { ERROR_401, ERROR_403 } from '@/settings/consts/api-error';
import * as $Logout from '@/subjects/logout';
import axios, { AxiosInstance, AxiosResponse } from 'axios';
import * as qs from 'qs';
import { API_URL } from '../settings/api-settings';
import { getLocalUserObj, getToken } from './session-data';
import { ErrorLogDTO, postErrorLog } from './utils';
import { deviceSpecs, deviceUuid } from './device';

class ClientHttp {
  private client: AxiosInstance;

  constructor(endpoint: string) {
    console.log('API URL: ' + endpoint);
    this.client = axios.create({
      baseURL: endpoint,
    });
  }

  public async get(url: string, params?: object, quiet: boolean = false): Promise<any> {
    return await this.request(url, {
        method: 'GET',
        params,
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
        }
      }, 
      quiet,
      true
    );
  }

  public async download(url: string, params?: object): Promise<AxiosResponse> {
    return await this.request(url, {
      method: 'GET',
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
      },
      responseType: 'blob',
    });
  }

  public async post(url: string, data?: object, params?: object): Promise<any> {
    return await this.request(url, { method: 'POST', data, params });
  }

  public async postMultipartFormData(url: string, data?: object): Promise<any> {
    return await this.sendMultipartFormData(url, 'POST', data);
  }

  public async putMultipartFormData(url: string, data?: object): Promise<any> {
    return await this.sendMultipartFormData(url, 'PUT', data);
  }

  public async sendMultipartFormData(url: string, method: string, data?: object): Promise<any> {
    const payload = new FormData();
    for (const key in data) {
      if (data[key] instanceof Array && data[key].length && data[key][0] instanceof File) {
        data[key].forEach(d => {
          this.appendFormData(payload, key, d);
        });
      } else {
        this.appendFormData(payload, key, data[key]);
      }
    }
    return await this.request(url, { method: method, data: payload });
  }

  private appendFormData(formData, key, obj) {
    if (!obj) {
      return;
    }
    if (obj instanceof File || obj instanceof Array || !this.isTypeAppJson(obj)) {
      formData.append(key, obj);
    } else {
      formData.append(key, new Blob([JSON.stringify(obj)], {
        type: "application/json"
      }));
    }
  }

  private isTypeAppJson(obj) {
    if (typeof obj == 'object') {
      try { 
        let json = JSON.stringify(obj); 
        return json.trim().indexOf("{") == 0;
      }
      catch (err) { return false; }
    }
  }

  checkJSON = function (m) {
    if (typeof m == 'object') {
      try { m = JSON.stringify(m); }
      catch (err) { return false; }
    }

    if (typeof m == 'string') {
      try { m = JSON.parse(m); }
      catch (err) { return false; }
    }

    if (typeof m != 'object') { return false; }
    return true;
  };

  public async delete(url: string, data?: object): Promise<any> {
    return await this.request(url, { method: 'DELETE', data });
  }

  public async put(url: string, data: object, params?: object): Promise<any> {
    return await this.request(url, { method: 'PUT', data, params });
  }


  lastRequestSuccess: Date = null;

  activeRequests = new Map();

  private async request(url: string, config: any, quiet: boolean = false, preventDuplicate: boolean = false): Promise<any> {
    let key = null;
    if (preventDuplicate) {
      key = `${url}_${config.method}_${JSON.stringify(config.params)}`;
      if (this.activeRequests.has(key)) {
        console.log('Preventing duplicate:', key, this.activeRequests.size);
        return this.activeRequests.get(key);
      }
    }

    const headers = await this.getHeaders();
    const result = this.client({ url, ...config, headers }).then(e => {
      this.lastRequestSuccess = new Date();
      return e;
    }).catch(
      (error) => {
        this.prepareAndPostErrorApi(error, url, config, headers);
        if (
          !quiet &&
          (
            error.response.status === ERROR_401 ||
            error.response.status === ERROR_403
          )
        ) {
          setTimeout(() => {
            $Logout.sessionExpired(url);
          }, 500);
        }

        throw error.response;
      },
    ).finally(() => {
      if (key) {
        this.activeRequests.delete(key);
      }
    });
    
    if (key) {
      this.activeRequests.set(key, result);
    }
    await result;
    return result;
  }

  private prepareAndPostErrorApi(error, url, config, headers) {
    let user: any = getLocalUserObj();
    let log = new ErrorLogDTO();
    if (user) {
      log.idLogin = user.idLogin;
      log.nomeUsuario = user.nome
    }
    log.url = url;
    log.href = window.location.href;
    log.httpStatus = error.response.status;
    log.configs = JSON.stringify(config, null, 4);
    log.headers = JSON.stringify(headers, null, 4);
    log.errors = JSON.stringify(error.response, null, 4);
    if (this.lastRequestSuccess) {
      log.segundosUltRequest = (new Date().getTime() - this.lastRequestSuccess.getTime()) / 1000;
    }
    if (error.response && error.response.data && error.response.data.message) {
      log.message = error.response.data.message;
    }
    postErrorLog(log);
  }

  private async getHeaders(): Promise<any> {
    const token = getToken();
    let headers = {
      ...axios.defaults.headers,
      deviceUuid: deviceUuid,
      deviceSpecs: deviceSpecs
    }
    if (!token) {
      return headers;
    }
    return {
      ...headers,
      Authorization: token,
    };
  }
}

export const apiClient = new ClientHttp(API_URL);
